/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListKeyWordAction } from '../../models/api-response-list-key-word-action';
import { KeyWordAction } from '../../models/key-word-action';

export interface CreateOrUpdateListOfKeyWordAction$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany: string;
      body: Array<KeyWordAction>
}

export function createOrUpdateListOfKeyWordAction(http: HttpClient, rootUrl: string, params: CreateOrUpdateListOfKeyWordAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListKeyWordAction>> {
  const rb = new RequestBuilder(rootUrl, createOrUpdateListOfKeyWordAction.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('refPhoneCompany', params.refPhoneCompany, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListKeyWordAction>;
    })
  );
}

createOrUpdateListOfKeyWordAction.PATH = '/v1/api/ui/key-word-action/create-update-list/{refPhoneCompany}';
